













































































































































































































































import BaseComponent from '../../../core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import {
  CompanyDto,
  CompanyDistrictDto,
  CompanyDistrictListDto,
  DeliveryFounderConsultContractListDto,
} from '../../../dto';
import CompanyService from '../../../services/company.service';
import CompanyDistrictService from '../../../services/company-district.service';
import { Pagination } from '../../../common';
import { CodeManagementDto } from '../../../services/init/dto';
import {
  APPROVAL_STATUS,
  CONST_APPROVAL_STATUS,
  CONST_PAGINATION_COUNT,
  PaginationCount,
} from '../../../services/shared';

import AmenityService from '../../../services/amenity.service';
import { getStatusColor } from '../../../core/utils/status-color.util';
import deliveryFounderConsultContractService from '@/services/delivery-founder-consult-contract.service';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'DeliveryFounderConsultContractList',
})
export default class DeliveryFounderConsultContractList extends BaseComponent {
  private deliveryFounderConsultContractList: CompanyDistrictDto[] = Array<
    CompanyDistrictDto
  >();
  private deliveryFounderConsultContractTotalCount = null;
  private deliveryFounderConsultContractSearchDto = new DeliveryFounderConsultContractListDto();
  private pagination = new Pagination();
  private approvalStatus: APPROVAL_STATUS[] = [...CONST_APPROVAL_STATUS];
  private companySelect: CompanyDto[] = [];
  private dataLoading = false;
  private addressData = {
    address: '',
  };

  private newLimit = null;
  private paginationCount: PaginationCount[] = [...CONST_PAGINATION_COUNT];

  private commonAmenityList = [];

  private newDate = new Date();
  // excel options
  private fields = {
    이름: 'nanudaUser.name',
    연락처: 'nanudaUser.phone',
    업체: 'deliverySpace.companyDistrict.company.nameKr',
    지점: 'deliverySpace.companyDistrict.nameKr',
    타입: 'deliverySpace.typeName',
    상담신청ID: 'deliveryFounderConsultNo',
  };
  private json_meta = [
    [
      {
        key: 'charset',
        value: 'utf-8',
      },
    ],
  ];

  getCompanies() {
    CompanyService.findForSelect().subscribe(res => {
      this.companySelect = res.data;
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    this.pagination.limit = this.newLimit;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(
        this.deliveryFounderConsultContractSearchDto,
        this.pagination,
      );
    }
    deliveryFounderConsultContractService
      .findAll(this.deliveryFounderConsultContractSearchDto, this.pagination)
      .subscribe(res => {
        if (res) {
          this.dataLoading = false;
          this.deliveryFounderConsultContractList = res.data.items;
          this.deliveryFounderConsultContractTotalCount = res.data.totalCount;
        }
      });
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.deliveryFounderConsultContractSearchDto = new DeliveryFounderConsultContractListDto();
      this.findAll();
    }
  }

  created() {
    this.newLimit = PaginationCount.TWENTY;
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.deliveryFounderConsultContractSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.newLimit = +query.limit;
        // this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCompanies();
  }
}
